import clsx from "clsx";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import type { IImageProps } from "@components/molecules/image/types";
import { Icon } from "@components/atoms/icons";
import { Typography } from "@components/atoms/typography";
import { useFileViewer } from "@/hooks/useFileViewer";

export function Image({
  containerClassName,
  className,
  alt,
  title,
  variant = "default",
  displayable = true,
  src,
  ...restProps
}: IImageProps) {
  const { t } = useTranslation("form");

  const { canShow, show } = useFileViewer({
    id: src?.id || "",
    name: title ? t(title) : src?.name || "",
    type: src?.type || "image/xxx",
    /* TODO: check later if backend doesnt return size find a way
     *  to calculate size in front
     */
    size: src?.size || 0,
    url: src?.url || "",
  });

  return (
    <div
      className={clsx(
        variant === "default" && classes.imageContainer,
        variant === "avatar" && classes.avatarContainer,
        containerClassName,
      )}
    >
      <img
        {...restProps}
        src={src?.url}
        alt={alt}
        className={clsx(
          classes.imageContainer__image,
          variant === "avatar" && classes.avatarContainer__image,
          className,
        )}
      />
      {canShow && displayable && (
        <div
          className={clsx(
            classes.imageContainer__cover,
            variant === "avatar" && classes.avatarCover,
          )}
          onClick={() => {
            show();
          }}
        >
          <Icon
            name={"Eye"}
            type={"bold-duotone"}
            color={"white"}
            fontSize={"2xl"}
          />
          {variant !== "avatar" && (
            <Typography color={"white"} fontSize={"base"} fontWeight={"bold"}>
              {title
                ? t("viewImageWithTitle", { title: t(title) })
                : t("viewImage")}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
}
